import Button from '@base/components/src/Button';
import { CheckoutStepsType } from '@package/core/src/checkout/types';
import { useRouter } from 'next/router';
import useNetworkStatus from '@package/hooks/src/useNetworkStatus';
import ValuedCustomerMessage from '../ValuedCustomerMessage';

import styles from './CheckoutButton.module.css';
import { CheckoutButtonProps } from './types';
import { useCallback, useEffect, useState } from 'react';

const CheckoutButton = ({
  id,
  checkoutButtonAvailable,
  redirectStart,
  notDeliverable,
  isUserAuthorized,
}: CheckoutButtonProps) => {
  const router = useRouter();
  const [isPending, setIsPending] = useState<boolean>(false)
  const [redirecting, setRedirecting] = useState<boolean>(false)
  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    if(!redirecting) return;

    setIsPending(true);

    if(isOnline) {
      if (notDeliverable) {
        void router.push(CheckoutStepsType.Payments);
        return;
      }
      void router.push(isUserAuthorized ? CheckoutStepsType.ShippingAddress : CheckoutStepsType.CheckoutLogin);
    }
  }, [redirecting, isOnline])

  return (
    <>
      {' '}
      {checkoutButtonAvailable ? (
        <ValuedCustomerMessage phoneNumber={checkoutButtonAvailable} />
      ) : (
        <Button
          id={id}
          data-testid={`proceed-to-checkout-btn-${id}`}
          fullWidth
          loading={isPending}
          largeButton
          classes={styles.proceedCheckoutButton}
          label={<p className={styles.proceedCheckoutButtonText}>Proceed to Checkout</p>}
          ariaLabel={'Proceed to Checkout'}
          onClick={() => setRedirecting(true)}
        />
      )}
    </>
  );
};

export default CheckoutButton;
